import {
  createEntityAdapter,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import { RootState } from 'src/store/index';

export type State = {
  loading: boolean;
};

export const adapter = createEntityAdapter<Model.PaymentMethodDetail>({
  selectId: (model) => model.metadata.class_user_id,
});

const { reducer, actions } = createSlice({
  name: 'payment_method_detail',
  initialState: adapter.getInitialState<State>({ loading: false }),
  reducers: {
    updateEntities(state, action: PayloadAction<Model.PaymentMethodDetail[]>) {
      adapter.upsertMany(state, action);
    },
    updateEntity(state, action: PayloadAction<Model.PaymentMethodDetail>) {
      adapter.upsertOne(state, action);
    },
    removeEntity(state, action: PayloadAction<string>) {
      adapter.removeOne(state, action.payload);
    },
    updateLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
  },
});

export const selector = adapter.getSelectors(
  (state: RootState) => state.model.payment_method_detail,
);

export { reducer };
export default actions;
